module.exports = __webpack_public_path__ + "static/media/day20_pagesync.2a1da781.gif";